import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getRouteMetadata } from '../utils/seoMetadata.js';
import { createStructuredData } from '../utils/structuredData.js';

function SeoHead() {
  const location = useLocation();
  const metadata = getRouteMetadata(location.pathname);
  const structuredData = createStructuredData(metadata);

  return (
    <Helmet prioritizeSeoTags>
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.description} />
      {metadata.keywords && <meta name="keywords" content={metadata.keywords} />}
      <meta name="robots" content={metadata.robots} />
      <meta property="og:type" content={metadata.ogType} />
      <meta property="og:site_name" content="Clientalio" />
      <meta property="og:title" content={metadata.ogTitle} />
      <meta property="og:description" content={metadata.ogDescription} />
      <meta property="og:image" content={metadata.ogImage} />
      <meta property="og:url" content={metadata.canonical} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metadata.twitterTitle} />
      <meta name="twitter:description" content={metadata.twitterDescription} />
      <meta name="twitter:image" content={metadata.twitterImage} />
      <link rel="canonical" href={metadata.canonical} />
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
    </Helmet>
  );
}

export default SeoHead;